module.exports = __webpack_public_path__ + "static/img/LOGO.cc64fb19.png";